import Vue from "vue";
import VueRouter from "vue-router";
import { router } from "./routes/routes";
import LightBootstrap from "./light-bootstrap-main";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { ToastPlugin } from "bootstrap-vue";
import { DropdownPlugin } from "bootstrap-vue";
import { ModalPlugin } from "bootstrap-vue";
import { ButtonPlugin } from "bootstrap-vue";
import { CalendarPlugin } from "bootstrap-vue";
import { SpinnerPlugin } from "bootstrap-vue";
import { createPinia, PiniaVuePlugin } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import VueSignaturePad from "vue-signature-pad";
import draggable from "vuedraggable";
import App from "./App.vue";
import globals from "./util/globals.js";
import { useLoginStore } from "./stores/loginStore.js";
import "./assets/styles/fonts.css";
import "./assets/styles/global.css";

Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(PiniaVuePlugin);
Vue.use(ToastPlugin);
Vue.use(DropdownPlugin);
Vue.use(ModalPlugin);
Vue.use(ButtonPlugin);
Vue.use(CalendarPlugin);
Vue.use(VueSignaturePad);
Vue.use(SpinnerPlugin);
Vue.component("Draggable", draggable);

const pinia = createPinia();
pinia.use(
  createPersistedState({
    storage: localStorage,
  }),
);

Vue.use(pinia);

const loginStore = useLoginStore(pinia);

Vue.prototype.$store = loginStore;
Vue.prototype.$global = globals;

new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  pinia,
});